import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';

import SamlSsoApplication from './SamlSsoApplication';

const SamlLoginPage = loadOnRoute(() => import('bundles/saml-sso/components/SamlLoginPage'));
const SSOReturnPage = loadOnRoute(() => import('bundles/saml-sso/components/SSOReturnPage'));

const routes = (
  <Route path="/" component={SamlSsoApplication}>
    <Route path="sso">
      <IndexRoute getComponent={SamlLoginPage} />
      <Route path="return/:method/:token" getComponent={SSOReturnPage} />
      <Route path="return" getComponent={SSOReturnPage} />
      <Route path=":slug" getComponent={SamlLoginPage} />
    </Route>
  </Route>
);

export default routes;
